import React from 'react';
import { Alert, Button } from 'antd';
import { Link } from 'react-router-dom';
function FreeDayMessage({status}) {
    if(status === "AVAILABLE")
    return (
        <Alert
        message="هدیه صفاتک"
        description="شما میتوانید یک روز رایگان از میز منعطف در صفاتک استفاده کنید."
        type="success"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
      /> 
    );
}

export default FreeDayMessage;